import { createReducer } from "@reduxjs/toolkit";
import * as ac from "./dEdmProductsActionCreators";
import { typePagination } from "model/system/constants";
import {logoutAC, resetReducers} from "model/system/systemActionCreators";

export type IdProductsState = {
  pagination: typePagination;
  filters: typeProductsFilters;
  data: IdProductsStateDataItem[];
  detailItemId: string | undefined;
};

export type typeProductsFilters = {
  name?: string | null;
  store?: string | null;
  active?: boolean | null;
  barcode?: string | null;
  marked?: boolean | null;
  category?: string | null;
  deleted?: boolean | null;
  invalidPsid?: true | null;
  integerUnit?: boolean | null;
};

export interface Root {
  content: {
    id: string;
    units: string;
    amount: number;
    product: {
      name: string;
      psid: string;
      barcode: string;
      marked: boolean;
    };
  }[];
  size: number;
  last: boolean;
  first: boolean;
  empty: boolean;
  number: number;
  totalPages: number;
  totalElements: number;
  numberOfElements: number;
  sort: {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
  };
  pageable: {
    offset: number;
    paged: boolean;
    unpaged: boolean;
    pageSize: number;
    pageNumber: number;
    sort: {
      empty: boolean;
      sorted: boolean;
      unsorted: boolean;
    };
  };
}

export type IdProductsStateDataItem = {
  id: string;
  units: string;
  amount: number;
  name: string;
  psid: string;
  barcode: string;
  marked: boolean;
};

export interface IdProductsStateDataSingleItem {
  id: string;
  store: {
    id: string;
    active: boolean;
    merchant: {
      id: string;
      tin: string;
      name: string;
      active: boolean;
    };
  };
  product: {
    id: string;
    name: string;
    productOwnerType: string;
    psid: string;
    marked: boolean;
    productType: string;
    barcodes: string[];
    merchant: {
      id: string;
      tin: string;
      name: string;
      active: boolean;
    };
  };
  units: string;
  amount: number;
  price: number;
  totalSum: number;
  vatRate: number;
  vatSum: number;
  markedLabels?: {
    id: string;
    label: string;
    sale: boolean;
  }[];
}

export const cleanFilterObject: typeProductsFilters = {
  marked: null,
  barcode: null,
};

export const initialState: IdProductsState = {
  data: [],
  pagination: {
    pageNumber: 0,
    itemsPerPage: 14,
  },
  detailItemId: undefined,
  filters: cleanFilterObject,
};

export const DEdmProductsReducer = createReducer(initialState, (builder) => {
  builder

    // Reducer of set data
    .addCase(ac.dEdmProductsSetDataAC, (state, action) => {
      state.data = action.payload.dataList;
    })

    // Reducer of set pagination
    .addCase(ac.dEdmProductsSetPaginationAC, (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload.pagination };
    })

    // Reducer of set items for page pagination
    .addCase(ac.dEdmProductsSetItemsForPageAC, (state, action) => {
      state.pagination = {
        ...state.pagination,
        pageNumber: 0,
        itemsPerPage: action.payload.itemsForPage,
      };
    })

    // Reducer of set pageNumber pagination
    .addCase(ac.dEdmProductsSetPageNumberAC, (state, action) => {
      state.pagination.pageNumber = action.payload.pageNumber;
    })

    // Reducer of set detail item
    .addCase(ac.dEdmProductsSetDetailItemAC, (state, action) => {
      state.detailItemId = action.payload;
    })

    // Reducer of clear filtersForm
    .addCase(ac.dEdmProductsClearFiltersAC, (state) => {
      state.filters = cleanFilterObject;
    })

    // Reducer of set filters
    .addCase(ac.dEdmProductsSetFiltersAC, (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
      state.pagination.pageNumber = 0;
    })

    // Reducer of clear state
    .addCase(logoutAC, (state) => {
      state.data = initialState.data;
      state.filters = initialState.filters;
      state.pagination = initialState.pagination;
      state.detailItemId = initialState.detailItemId;
    })

    .addCase(resetReducers, (state, action) => {
        if (action.payload !== "products") {
          state.data = initialState.data;
          state.filters = initialState.filters;
          state.pagination = initialState.pagination;
          state.detailItemId = initialState.detailItemId;
        }
    });
});
